export default "__VITE_ASSET__9uDoCZtn__"